import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';


import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {InputComponent} from './components/forms/input/input.component';
import {HomeComponent} from './components/home/home.component';
import {NavbarComponent} from './components/navbar/navbar.component';
import {DropdownComponent} from './components/forms/dropdown/dropdown.component';
import {MatDialogModule} from '@angular/material';
import {UserInputComponent} from './components/user-input/user-input.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatSnackBarModule} from '@angular/material/snack-bar';


@NgModule({
	declarations: [
		AppComponent,
		InputComponent,
		HomeComponent,
		NavbarComponent,
		DropdownComponent,
		UserInputComponent
	],
	imports: [
		BrowserModule,
		AppRoutingModule,
		BrowserAnimationsModule,
		MatDialogModule,
		FormsModule,
		MatProgressSpinnerModule,
		ReactiveFormsModule,
		MatSnackBarModule
	],
	providers: [],
	bootstrap: [AppComponent],
	entryComponents: [
		UserInputComponent
	],
})
export class AppModule {
}
